export default import.meta.ROLLUP_FILE_URL_rN_1li4k2aIbHGs0zKW8QQ;